/**
 * FairPaginationBar — RedisiginProductPage PaginationSegment / PaginationBar (1:1190)
 * Progress-style pager (≠ numeric FairPaginator)
 */

export const FAIR_PAGINATION_SEGMENT_KINDS = [
  'leading',
  'center',
  'trailing',
] as const
export type FairPaginationSegmentKind =
  (typeof FAIR_PAGINATION_SEGMENT_KINDS)[number]

export function resolveFairPaginationSegmentKind(
  index: number,
  total: number,
): FairPaginationSegmentKind {
  if (index <= 0) {
    return 'leading'
  }
  if (index >= total - 1) {
    return 'trailing'
  }
  return 'center'
}

/** Skip motion only for last↔first wrap on 3+ items (2-item 0↔1 must still animate). */
export function shouldSkipFairPaginationMotion(
  prev: number,
  next: number,
  total: number,
): boolean {
  if (total <= 2) return false
  const last = total - 1
  return (prev === last && next === 0) || (prev === 0 && next === last)
}
